import { PutObjectCommand, S3Client } from '@aws-sdk/client-s3'
import { bucketName, s3Confid, upload_url } from '.'
import axios from 'axios'

// const s3 = new S3Client(s3Confid)

export const uploadImageToS3 = async (file, folder) => {
  if (!file) throw new Error('No file provided')

  try {
    const fileName = `${Date.now()}-${file.name}`

    // Step 1: Get presigned URL
    const res = await axios.post(
      upload_url,
      {
        fileName,
        folder,
        contentType: file.type || 'application/octet-stream',
      },
      {
        headers: { 'Content-Type': 'application/json' },
      },
    )

    // console.log("Raw axios response data:", res.data); // This will show the string

    // Parse if it's a string (non-proxy case)
    // Lambda Function URL returns { statusCode, body }
    let data
    if (res.data && res.data.body) {
      try {
        data = JSON.parse(res.data.body)
      } catch (e) {
        throw new Error('Failed to parse response body')
      }
    } else {
      data = res.data // fallback
    }

    const { success, presignedUrl, publicUrl } = data

    if (!success || !presignedUrl) {
      throw new Error('Invalid response: missing required fields')
    }

    // TEMP FIX: If publicUrl is missing, construct it manually
    let finalPublicUrl = publicUrl
    if (!finalPublicUrl && presignedUrl) {
      // Extract key from presignedUrl and build public URL
      try {
        const url = new URL(presignedUrl)
        const key = url.pathname.slice(1) // remove leading /
        finalPublicUrl = `https://${process.env.REACT_APP_S3_BUCKET_NAME || 'your-bucket'}.s3.${process.env.REACT_APP_AWS_REGION || 'us-east-1'}.amazonaws.com/${key}`
      } catch (e) {
        console.warn('Could not construct publicUrl from presignedUrl')
      }
    }

    if (!finalPublicUrl) {
      throw new Error('Missing publicUrl from server')
    }

    // console.log("Using public URL:", finalPublicUrl);

    // // Then proceed with PUT upload...
    const uploadResponse = await axios.put(presignedUrl, file, {
      headers: {
        'Content-Type': file.type || 'application/octet-stream',
      },
    })

    return finalPublicUrl
  } catch (err) {
    console.error('Upload error:', err.response?.data || err.message || err)
    throw new Error('Failed to upload file')
  }
}


